export default "__VITE_ASSET__cefd68b7__"